export default __webpack_public_path__ + "static/media/drone7.94456aef.jpg";